import { RedDayCriteriaType } from "./NonProductionDayType";

export const RedDayCriterias = [
  { type: RedDayCriteriaType.Non_SMS, value: false },
  { type: RedDayCriteriaType.Non_Printing, value: false },
  { type: RedDayCriteriaType.Non_EHF, value: false },
  { type: RedDayCriteriaType.Non_Email, value: false },
];

export enum NonProdDayStatus {
  New = 0,
  Exists = 1,
  Conflict = 2,
  Copied = 3,
  Edited = 4,
}

export const NON_PROD_DAY_STATUS_COLORS: Record<NonProdDayStatus, string> = {
  [NonProdDayStatus.New]: "green",
  [NonProdDayStatus.Exists]: "blue",
  [NonProdDayStatus.Conflict]: "red",
  [NonProdDayStatus.Copied]: "purple",
  [NonProdDayStatus.Edited]: "orange",
};

export const NON_PROD_DAY_STATUS_LABELS: Record<NonProdDayStatus, string> = {
  [NonProdDayStatus.New]: "US.COLLECTION.ADMIN:COPY_CALENDAR.NEW",
  [NonProdDayStatus.Exists]: "US.COLLECTION.ADMIN:COPY_CALENDAR.EXISTS",
  [NonProdDayStatus.Conflict]: "US.COLLECTION.ADMIN:COPY_CALENDAR.CONFLICT",
  [NonProdDayStatus.Copied]: "US.COLLECTION.ADMIN:COPY_CALENDAR.COPIED",
  [NonProdDayStatus.Edited]: "US.COLLECTION.ADMIN:COPY_CALENDAR.EDITED",
};
